export default {
  warehouseContract: {
    search: {
      contractNo: '合同号',
      contractNoPlaceholder: '请输入合同号',
      contractEnterpriseNo: '签约单位',
      contractEnterpriseNoPlaceholder: '请选择签约单位',
      signDateStart: '签署日期从',
      signDateStartPlaceholder: '请选择签署日期从',
      signDateEnd: '签署日期到',
      signDateEndPlaceholder: '请选择签署日期到',
      contractStatus: '状态',
      contractStatusPlaceholder: '请选择合同状态',
    },
    table: {
      contractNo: '合同号',
      contractStatus: '状态',
      contractEnterpriseNo: '签约单位',
      signDate: '签署日期',
      valideDateTo: '合同有效期',
      chargeStandard: '收费标准',
      goodsControlAmount: '控货金额',
      createBy: '制单人',
      contractMark: '备注',
      inableMessage: '只是已禁用状态下可以启用',
      disabledMessage: '只有已生效状态下可以禁用',
      deleteMessage: '只有已禁用状态下可以删除',
      quitMessage: '只有驳回状态下可以放弃',
      canNotEditMessage: '审批中和已禁用状态下不能修改',
    },
    form: {
      history: '历史记录',
      warehouseInfo: '仓储信息',
      goodsInfo: '商品信息',
      attachmentInfo: '附件',
      basicInfo: '基本信息',
      systemInfo: '系统信息',
      contractEnterpriseNo: '签约单位',
      contractEnterpriseNoPlaceholder: '请选择签约单位',
      registeredAssets: '注册资本',
      registeredAssetsPlaceholder: '请输入注册资本',
      contactPersonNo: '联系人',
      contactPersonNoPlaceholder: '请输入联系人',
      contactPhone: '联系方式',
      contactPhonePlaceholder: '请输入联系方式',
      signDate: '签署日期',
      signDatePlaceholder: '请选择签署日期',
      valideDateTo: '合同有效期',
      valideDateToPlaceholder: '请输入合同有效期',
      inboundMethod: '入库方式',
      inboundMethodPlaceholder: '请选择入库方式',
      stationName: '到站名称',
      stationNamePlaceholder: '请输入到站名称',
      goodsControlAmount: '控货金额',
      goodsControlAmountPlaceholder: '请输入控货金额',
      signAddress: '签约地点',
      signAddressPlaceholder: '请输入签约地点',
      contractVenue: '合同管辖地',
      contractVenuePlaceholder: '请输入合同管辖地',
      chargeStandard: '收费标准',
      chargeStandardPlaceholder: '请输入收费标准',
      productCategory: '商品品种',
      productCategoryPlaceholder: '请输入商品品种',
      feature: '功能',
      featurePlaceholder: '请输入功能',
      storageNo: '仓库编码',
      storageName: '仓库名称',
      storageAddress: '仓库地址',
      storagePlaceholder: '请选择仓库',
      storageAddressPlaceholder: '请输入仓库地址',
      goodName: '商品名称',
      goodNamePlaceholder: '请选择商品',
      storageExpense: '仓储费',
      storageExpensePlaceholder: '请输入仓储费',
      contractCompanyNo: '公司',
      contractCreatePersonNo: '创建人',
      contractCreateDate: '创建时间',
      contractMark: '备注',
      contractCompanyNoPlaceholder: '请输入公司',
      contractCreatePersonNoPlaceholder: '请输入创建人',
      contractCreateDatePlaceholder: '请输入创建时间',
      contractMarkPlaceholder: '请输入备注',
      productGoodPlaceholder: '请选择商品名称',
      storageNoPlaceholder: '请选择仓库名称',
      gmtCreate: '时间',
      editTitle: '修改原因',
      editResonPlaceholder: '请输入修改原因',
      updateContent: '变更信息',
      disabledTitle: '禁用',
      disabledReason: '禁用理由',
      disabledReasonPlaceholder: '请输入禁用理由',
      goodsInfoMessage: '请完善商品信息',
    },
  },
};
